import {SvgIconComponent, TrendingUpOutlined } from "@mui/icons-material";
import BoltOutlined from "@mui/icons-material/BoltOutlined";
import BarChartOutlined from "@mui/icons-material/BarChartOutlined";
import ForumOutlined from "@mui/icons-material/ForumOutlined";
import ManageSearchOutlined from "@mui/icons-material/ManageSearchOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import TravelExploreOutlined from "@mui/icons-material/TravelExploreOutlined";
import NewspaperOutlined from "@mui/icons-material/NewspaperOutlined";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import RepeatOnOutlinedIcon from '@mui/icons-material/RepeatOnOutlined';

export const MATERIAL_ICON_MAP: Record<string, SvgIconComponent> = {
  document_search: ManageSearchOutlined,
  forum: ForumOutlined,
  chart_data: TrendingUpOutlined,
  bar_chart: BarChartOutlined,
  school: SchoolOutlined,
  bolt: BoltOutlined,
  travel_explore: TravelExploreOutlined,
  news: NewspaperOutlined,
  settings: SettingsOutlinedIcon,
  balance: BalanceOutlinedIcon,
  repeat_on: RepeatOnOutlinedIcon
};

export const DEFAULT_USE_CASE_ICON = BoltOutlined;

export const WORKFLOW_CARDS_TITLE = "Choose a use case";

export const WORKFLOW_CARDS_INCENTIVE =
  "Or stay in default mode and start typing your message";

export const LOADING_TEXT = "Loading Use Cases...";

export const WORKFLOW_CARDS_MORE = "Explore additional use cases";

export const WORKFLOW_CARDS_MORE_COMING_SOON = "Coming soon";
